import { sortBy } from 'lodash'
import { CustomCartItem as CartItem } from 'data/cartItems'
import { MagentoMoney } from 'lib/types'

export interface CartTotals {
  grandTotal: MagentoMoney
  subscriptionItemsInCart: CartItem[]
  subscriptionItemsPricesByFrequency: CartItem[]
}

export interface SubscriptionItem {
  frequencyInCart: string
  itemTotal: number
  hasSpecialSupply: string
  productName: string
}
// TODO: Get this info from the BE
const FIXED_DISCOUNT = 0.1

export const useCartTotals = (items?: CartItem[]) => {
  const subscriptionItemsInCart = items?.reduce((acc: any, item: any) => {
    if (item?.frequencyInCart) {
      const cartItemPrice = item?.prices?.row_total?.value
      const productPrice =
        item?.product?.price.regularPrice.amount.value * item?.quantity
      const hasPromoProduct = item?.associatedPromoHash
      let itemTotal
      if (cartItemPrice === 0 && hasPromoProduct) {
        const discount = productPrice * FIXED_DISCOUNT
        itemTotal = productPrice - discount
      } else {
        itemTotal = cartItemPrice - item?.prices?.total_item_discount?.value
      }

      acc?.push({
        frequencyInCart: item?.frequencyInCart,
        itemTotal,
        productName: item?.product?.name,
        hasSpecialSupply: item?.associatedPromoHash
      })
    }
    return acc
  }, [])

  const subscriptionItemsPricesByFrequency: SubscriptionItem[] = Object.values(
    subscriptionItemsInCart.reduce(function (obj: any, item: SubscriptionItem) {
      var key = item.frequencyInCart + '|' + item.hasSpecialSupply
      if (!obj[key]) obj[key] = item
      else {
        obj[key].itemTotal = (obj[key].itemTotal as number) + item.itemTotal
        obj[key].productName = [obj[key].productName, item.productName].join(
          ', '
        )
      }
      return obj
    }, {})
  )
  const sortedItems = sortBy(
    subscriptionItemsPricesByFrequency,
    (item) => item.hasSpecialSupply,
    ['desc']
  )

  return {
    subscriptionItemsInCart,
    subscriptionItemsPricesByFrequency: sortedItems
  }
}

export const useCartSubscriptions = (cartItem: CartItem) => {
  const {
    product,
    quantity,
    variantProduct: variant,
    frequencyInCart,
    prices,
    associatedPromoHash: hasPromoProduct,
    associatedProduct
  } = cartItem ?? {}

  const subscriptionItem = frequencyInCart
  const shipmentFrequency = frequencyInCart && parseInt(frequencyInCart) / 7
  const packageQty =
    product?.customAttribute?.package_qty ??
    variant?.customAttribute?.package_qty ??
    associatedProduct?.product?.customAttribute?.package_qty
  const cartItemPrice = prices?.price.value
  const ProductItemPrice = product.price.regularPrice.amount.value ?? 0
  const hasSpecialOffer = cartItemPrice === 0 && hasPromoProduct
  let itemSubtotalWithDiscount
  if (hasSpecialOffer) {
    const subtotal = ProductItemPrice * quantity
    const specialOffer = subtotal * FIXED_DISCOUNT
    itemSubtotalWithDiscount = subtotal - specialOffer
  } else {
    itemSubtotalWithDiscount =
      cartItemPrice * quantity - (prices.total_item_discount?.value ?? 0)
  }

  return {
    subscriptionItem,
    product,
    shipmentFrequency,
    variant,
    quantity,
    packageQty,
    itemSubtotalWithDiscount,
    associatedProduct,
    cartItemPrice
  }
}

export const useCartItems = (items?: CartItem[]) => {
  const productWithSpecialSupply = items?.filter(
    (item) => item.associatedPromoHash && (item?.promoQty !== undefined && !(item.promoQty > 0))
  )
  const cartItems = items?.map((item) =>
    Object.assign({}, item, { associatedProduct: {} })
  )
  if (productWithSpecialSupply && productWithSpecialSupply?.length > 0) {
    productWithSpecialSupply?.forEach((specialItem) => {
      cartItems?.find((item, i) => {
        if (item?.associatedPromoHash === specialItem?.associatedPromoHash && (item?.promoQty !== undefined && item?.promoQty > 0)) {
          item.associatedProduct = specialItem

          const productIndex = cartItems.findIndex(
            (i) =>
              i.associatedPromoHash === item?.associatedPromoHash &&
              (i.promoQty !== undefined && i.promoQty === 0)
          )
          if (productIndex > -1) {
            cartItems.splice(productIndex, 1)
          }
        }

        return null
      })
    })

    const sortedItems = sortBy(cartItems, (item) => item.associatedProduct.id, [
      'desc'
    ])
    return sortedItems
  }

  return cartItems
}
